import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7885fa0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brand" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "label" }

import { ref, onMounted, onUpdated, computed } from "vue";
import { V1_MENU_LIST_ALL } from "@/api/const/menu";
import { apiPost, apiGetNoParam, apiGet } from "@/api/index";
import commons from "@/utils/Common";
import { COMPANY_DETAIL_COOKIE } from '@/const/ConstCookies'
interface props {
  sidebarCollapsed: boolean;
  sidebarColor: string;
  sidebarTheme: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardSidebar',
  props: {
    sidebarCollapsed: { type: Boolean, default: false },
    sidebarColor: { default: "primary" },
    sidebarTheme: { default: "light" }
  },
  setup(__props: any) {

const propsData = __props;

onMounted(async () => {
  await loadData();
});
const menuList = ref([])
const companys:any = ref({});
const loadData = async () => {
  companys.value = commons.getCookies(COMPANY_DETAIL_COOKIE)
  await apiGetNoParam(V1_MENU_LIST_ALL).then((res) => {
    let response: any = res;
    menuList.value = response.data.data;
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!

  return (_openBlock(), _createBlock(_component_a_layout_sider, {
    collapsible: "",
    class: _normalizeClass(["sider-primary", [
      'ant-layout-sider-' + _ctx.sidebarColor,
      'ant-layout-sider-' + _ctx.sidebarTheme,
    ]]),
    breakpoint: "lg",
    "collapsed-width": "0",
    width: "250px",
    collapsed: _ctx.sidebarCollapsed,
    onCollapse: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleSidebar', !_ctx.sidebarCollapsed))),
    trigger: null,
    theme: "light",
    style: { backgroundColor: 'transparent' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "logo d-flex align-items-center me-xl-0",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
        }, [
          _createVNode(_component_el_image, {
            style: {"width":"250px"},
            src: companys.value.logo,
            fit: "contain"
          }, null, 8, ["src"])
        ])
      ]),
      _hoisted_2,
      _createVNode(_component_a_menu, { theme: "light" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_a_menu_item, {
              key: index,
              class: _normalizeClass(item.menuClass)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  to: item.linkTo,
                  class: _normalizeClass(item.routerClass)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(item.spanClass)
                    }, [
                      _createElementVNode("div", {
                        innerHTML: item.icon
                      }, null, 8, _hoisted_3)
                    ], 2),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(item.linkLabel)), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "class"])
              ]),
              _: 2
            }, 1032, ["class"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["collapsed", "class"]))
}
}

})